<template>
  <div class="layout">
    <!-- 左侧导航 -->
    <div class="menu">
      <Menu :isCollapse="isCollapse"></Menu>
    </div>
    <!-- 右侧内容 -->
    <div :class="isCollapse ? 'small' : 'content'">
      <div :title="isCollapse ? '点击展开' : '点击收起'" class="box_bgd" @click="isC">
        <!-- 点击展开收起导航和切换对应图标 -->
        <i
          :class="
            !isCollapse
              ? 'iconfont icon-shousuocaidan-copy'
              : 'iconfont icon-shousuocaidan'
          "
        ></i>
      </div>
      <Content :is-collapse="isCollapse"></Content>
    </div>
  </div>
</template>
<script>
import Menu from "./menu/Index.vue";
import Content from "./content/Index.vue";
export default {
  components: {
    Menu,
    Content
  },
  data() {
    return {
      isCollapse: false
    };
  },
  created() {},
  methods: {
    isC() {
      this.isCollapse = !this.isCollapse;
    }
  }
};
</script>
<style lang="less" scoped>
.layout {
  // display: flex;
  .menu {
    // width: 200px;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    color: var(--theme-sidebar-text, rgb(191, 203, 217));
    background: var(--theme-sidebar-bg, #304156);
    overflow-y: scroll;
  }
  .content {
    padding-left: 200px;
    min-height: 100vh;
  }
  .small {
    padding-left: 75px;
  }
}
.box_bgd {
  position: fixed;
  top: 15px;
  left: 210px;
  z-index: 1001;
  font-weight: bold;
  cursor: pointer;
}
.small .box_bgd {
  left: 85px;
}
.box_bgd i {
  font-size: 20px;
}
::-webkit-scrollbar {
  display: none;
}
</style>